import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isAdvertorial, isCustom } from '../../advertorial/advertorial';
import get from 'lodash/get';

export default class ByLine extends Component {
  shouldComponentUpdate() {
    return false;
  }

  renderAuthorLink() {
    const { bylineAttribution, post } = this.props;
    const { author } = post;

    const existingAuthors = get(post, 'customFields.existingAuthors', []) || [];
    const guestAuthors = get(post, 'customFields.guestAuthors', []) || [];

    const tags = Array.from(post.tags, tag => tag.slug);

    if (existingAuthors.length > 0 || guestAuthors.length > 0) {
      return (
        <React.Fragment>
          {this.props.specialRedesignArticle ? '' : 'By'}
          {existingAuthors.map((existingAuthor, index) => {
            if (
              index === existingAuthors.length - 1 &&
              guestAuthors.length === 0
            ) {
              return (
                <React.Fragment>
                  {' and '}
                  <a href={`/user/${existingAuthor.user_nicename}`}>
                    {existingAuthor.display_name}
                  </a>
                </React.Fragment>
              );
            }
            return (
              <a href={`/user/${existingAuthor.user_nicename}`}>
                {` ${existingAuthor.display_name},`}
              </a>
            );
          })}
          {guestAuthors.map((guestAuthor, index) => {
            if (guestAuthors.length === 1) {
              return ` ${guestAuthor.authorName}`;
            }
            if (
              guestAuthors.length === 2 &&
              index === guestAuthors.length - 1
            ) {
              return ` and ${guestAuthor.authorName}`;
            }
            if (
              guestAuthors.length === 3 &&
              index === guestAuthors.length - 2
            ) {
              return `, ${guestAuthor.authorName}, and`;
            }
            return ` ${guestAuthor.authorName}`;
          })}
        </React.Fragment>
      );
    }

    if (tags.includes('fast-company-executive-board') && author.url) {
      return (
        <a href={author.url} target="_blank">
          By {author.name}
        </a>
      );
    }

    if (bylineAttribution) {
      return `By ${bylineAttribution} `;
    }

    return (
      <a href={`/user/${author.slug}`}>
        <span className="bySpan">By</span> {author.name}
      </a>
    );
  }

  render() {
    const { live } = this.props;
    const { readTime, tags } = this.props.post;
    const isAdvertorialOrCustom = isAdvertorial(tags) || isCustom(tags);
    const byline = get(this.props, 'bylineAttribution', '');
    const hideByline = get(this.props, 'post.customFields.hide_byline', false);

    return (
      <div className="post__byline">
        {!hideByline && (
          <cite className={`${byline ? 'post__no_highlight' : 'post__by'}`}>
            {this.renderAuthorLink()}
          </cite>
        )}
        {live || isAdvertorialOrCustom ? null : (
          <span className="post__readTime">{readTime} Read</span>
        )}
      </div>
    );
  }
}

ByLine.defaultProps = {
  live: false,
  specialRedesignArticle: false
};

ByLine.propTypes = {
  post: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    author: PropTypes.shape({}).isRequired,
    readTime: PropTypes.string.isRequired,
    customFields: PropTypes.shape({
      hide_byline: PropTypes.bool
    })
  }).isRequired,
  bylineAttribution: PropTypes.string.isRequired,
  live: PropTypes.bool,
  specialRedesignArticle: PropTypes.bool
};
